import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { StoreService } from '../store/store.service';
import { DEALER_ID_PARAM } from '../../constants/query-params';

/**
 * Listens for the optional `dealerId` query parameter on any URL route
 * and syncs it into the application store so it can be sent when creating an application.
 */
@Injectable({ providedIn: 'root' })
export class DealerIdQueryService {
  private readonly router = inject(Router);
  private readonly store = inject(StoreService);

  constructor() {
    // Listen to any future query change events
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe(() => this.syncDealerIdFromUrl());

    // Get inital query param value
    this.syncDealerIdFromUrl();
  }

  /**
   * Helper method to get dealerId value from query parameter
   */
  private syncDealerIdFromUrl(): void {
    // Parse router tree for dealer id
    const tree = this.router.parseUrl(this.router.url);
    const value = tree.queryParams[DEALER_ID_PARAM];
    const dealerId = typeof value === 'string' && value.trim() ? value.trim() : null;

    // Only update if non-null
    if (dealerId != undefined) {
      this.store.setDealerId(dealerId);
    }
  }
}
